
import Breadcrumb from '@/components/Breadcrumb'
import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2'
const OrderPayDialog = () => import('@/components/OrderPayDialog')
import { addQueryParams } from '@/utils'
import { mapGetters } from 'vuex'
// 卡券组件
import CouponItem from '@/components/CouponItem'
import CouponModal from '@/components/CouponModal'
import { RestrictMallCode } from '@/enum/localEnum'
import { formatCount } from '~/utils'
import countTo from 'vue-count-to'
export default {
    components: {
        CouponItem,
        TitleBox,
        TitleBox2,
        OrderPayDialog,
        Breadcrumb,
        CouponModal,
        countTo
    },
    data() {
        return {
            inviteInfo: {},
            parChangeState: true, // 勾选协议
            centerDialogVisible2: false, // 购买须知
            centerPayDialogVisible: false, // 支付方式
            centerPayQRDialogVisible: false, // 关闭支付提示
            detailsData: null, // 商品信息
            calculateFee: null, //意向金
            /** 这两个字段应该用不上了 */ 
            compensationList: [], //基础包赔列表
            compensationListTwo: [], //增值包赔列表
            compensationFee: 0, //包赔金额
            compensationName: null, //包赔名称
            totalPrice: '', //总价
            parInfo: {}, //创建订单回调信息
            articleDetail: null, //购买须知
            orderActive: false,
            compensationVisible: false, // 包赔信息弹窗
            valueAddCompensationIds: [], //增值包赔id合集
            compensationDetail: '', //包赔规则
            compensationAttentionItems: '', // 注意事项
            compensationVisibleData: '', // 包赔弹窗选中数据
            orderType: '',
            // 是否必选包赔
            compensation: {
                compensationAddNeed: null, //是否必选增值包赔
                compensationBasicNeed: null //是否必选基础包赔
            },

            // usedcoupon: {}, // 选中要使用的优惠券
            couponTipsModalShow: false, // 优惠券使用提示弹框
            couponLoading: false, // 获取优惠券的loading
            dialogTitle: '购买协议',
            activeName: 'true',
            activeNameNum: 'true',
            tabs: [
                {
                    name: 'true',
                    label: '可用',
                    count: 0
                },
                {
                    name: 'false',
                    label: '不可用',
                    count: 0
                }
            ],
            //基础包赔列表
            basicCompensationList: [],
            //增值包赔列表
            plusCompensationList: [],
            // 选中的基础包赔信息
            selectedBasicCompensation: {},
            // 选中的增值包赔信息
            selectedPlusCompensation: [],
            // 包赔服务信息
            compensationServiceInfo: {},
            //优惠卷列表
            couponList: [],
            // 选中的优惠券
            selectedCoupon: {},
            wantNum: 0,
            wantBuyText: '',
            shouldAnimate: false,
            inviteInfo:{},
            inviteCode:''
        }
    },
    computed: {
        ...mapGetters({
            gameList: 'game/gameList',
            payInfo: 'game/payInfo',
            userAccount: 'user/userAccount'
        }),
        /**
         * 选中的增值包赔列表
         */
        plusSelectedList() {
            return this.plusCompensationList.filter(item => this.selectedPlusCompensation.includes(item.id))
        },

        /**
         * 计算订单总价
         */
        orderTypeTotalPrice() {
            const { orderType, fictitiousOrderPrice, labelPrice, modifyPrice } = this.$route.query
            const { price, transactionPrice } = this.detailsData
            let totalPrice = 0
            switch (orderType) {
                case 'fictitiousOrder':
                    totalPrice = fictitiousOrderPrice
                    break;
                case 'LABEL':
                    totalPrice = labelPrice
                    break;
                case 'orderUpdatePricePay':
                case 'recyclePrice':
                case 'buyerSeller':
                    totalPrice = modifyPrice
                    break;
                default:
                    totalPrice = price || transactionPrice
                    break;
            }
            return totalPrice

        },
        /**
         * 计算优惠券实际减免金额
         */
        couponRealPrice() {
            const leng = Object.keys(this.selectedCoupon).length
            if (!leng) return 0
            const { couponsValue, scopeBusiness } = this.selectedCoupon
            // 基础包赔费用
            const baseFee = Object.hasOwn(this.selectedBasicCompensation, 'compensationFee') ? this.selectedBasicCompensation.compensationFee : 0

            // 增值包赔费用
            let plusFee =  0
            if (this.selectedPlusCompensation.length) {
                // 计算已选中的增值包赔费用
                this.plusSelectedList.forEach(item => {
                    plusFee += Number(item.compensationFee)
                })
            }
            const totalFee = Number(baseFee) + Number(plusFee)
            const couponNumber = Number(couponsValue)
            // 优惠券可用业务 1：包赔费用、2：订单总价
            if (scopeBusiness === 1) {
                // 优惠券实际减免金额 = 基础包赔费用 + 增值包赔费用
                return Math.min(totalFee, couponNumber)
            }
            if (scopeBusiness === 2) {
                const totalPrice = Number(this.orderTypeTotalPrice) + totalFee
                return Math.min(totalPrice.toFixed(2), couponNumber)
            }
            return 0

        },
        /**
         * 计算实付金额
         */
        setTotal() {
            // 总价 - 优惠券实际减免金额
            let total = Number(this.orderTypeTotalPrice) - this.couponRealPrice - Number(this.merchantDiscount)
            // 基础包赔费用
            const baseFee = Object.hasOwn(this.selectedBasicCompensation, 'compensationFee') ? this.selectedBasicCompensation.compensationFee : 0
            // 增值包赔费用
            let plusFee = 0
            if (this.selectedPlusCompensation.length) {
                // 计算已选中的增值包赔费用
                this.plusSelectedList.forEach(item => {
                    plusFee += Number(item.compensationFee)
                })
            }
            if (baseFee) {
                total += baseFee + Number(plusFee)
            }
            return total? total.toFixed(2) : 0
        },
        /**
         * 拆分实付金额的整数和小数
         */
        disassemblePrice() {
            const _price = String(this.setTotal)?.split('.')
            return [_price[0], _price[1]]
        },
        /**
         * 选中的包赔列表
         */
        selectCompensationList() {
            let result = []
            // 检查基础包赔是否选中
            const leng = Object.keys(this.selectedBasicCompensation).length
            if (leng) {
                result.push(this.selectedBasicCompensation)
            }
            // 检查增值包赔是否选中
            if (this.selectedPlusCompensation.length) {
                result = result.concat(this.plusSelectedList)
            }
            return result
        },
        /**
         * 计算号商折扣
         */
        merchantDiscount() {
            let total = 0
            this.selectCompensationList.forEach(item => {
                if (item.merchantDiscountAmount) {
                    total += Number(item.merchantDiscountAmount)
                }
            })
            return total.toFixed(2)
        },
    },
    watch: {
        $route: {
            async handler(route) {
                if (process.client) {
                    this.orderType = route.query.orderType || 'normal'
                    await this.onLoadDetailsData()
                    this.totalPrice = this.orderTypeTotalPrice
                    this.getGameConfigData(this.detailsData)
                    this.getCompensationList()
                    this.getCalculateFee()
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        /**
         * 优惠券tab切换
         * @param tab
         */
        handleClickTab(tab) {
            if (this.activeNameNum === tab.name) {
                return
            }
            this.activeNameNum = tab.name
            this.getWaitUseCouponList()
        },
        // 包赔是否必填
        checkCompensation(compensationNeed, list, compensationId, errorMessage) {
            if (compensationNeed) {
                if (!list?.length) {
                    this.$message.error('包赔服务错误，请联系客服')
                    return false
                } else if (!compensationId) {
                    this.$message.error(errorMessage)
                    return false
                }
            }
            return true
        },
        
		// 推广码输入限制 - 与表单数据双向绑定
		handleInviteCodeInput(event) {

            console.log(event,'===');
            
            const value = event
			// 只允许数字和字母，并限制8位
			const filteredValue = value.replace(/[^0-9a-zA-Z]/g, '').substring(0, 8)
			// 更新到表单数据中
			this.inviteCode = filteredValue
			// 更新输入框显示
			event = filteredValue
		},

		checkCode(){
	        if (!this.inviteCode) return
			this.$api.checkActivityBenefitInviteCode(this.inviteCode).then(res=>{
				if(!res.data){
					this.$message.error('推广码不存在或已过期！')
				}
			})
		},

		handleInviteCodeKeypress(event){
			const char = String.fromCharCode(event.which)
			// 如果不是数字或字母，阻止输入
			if (!/[0-9a-zA-Z]/.test(char)) {
				event.preventDefault()
			}
			// 如果已经达到8位，阻止继续输入
			if (this.inviteCode && this.inviteCode.length >= 8) {
				event.preventDefault()
			}
		},
        async paymentSubmitData(data) {
            let res
            switch (this.orderType) {
                case 'fictitiousOrder':
                    data.action.fictitiousOrderId = this.$route.query.fictitiousOrderId
                    res = await this.$api.createFictitiousOrder(data)
                    break
                case 'LABEL':
                    data.action.labelId = this.$route.query.labelId
                    data.action.orderType = 'LABEL'
                    res = await this.$api.fullOrderCreate(data)
                    break
                case 'orderUpdatePricePay':
                    data.action.oldOrderNo = this.$route.query.oldOrderNo
                    data.action.businessSource = 'UPDATE_PRICE'
                    res = await this.$api.createFictitiousOrder(data)
                    break
                case 'recyclePrice':
                    if (this.$route.query.type === '1') {
                        data.action.reclaimPriceId = this.$route.query.reclaimPriceId
                    }
                    data.action.businessSource = 'RECLAIM'
                    data.action.isRecycle = true
                    res = await this.$api.createFictitiousOrder(data)
                    break
                case 'buyerSeller':
                    if (this.$route.query.type === '2') {
                        data.action.coalitionPriceId = this.$route.query.reclaimPriceId
                    }
                    data.action.businessSource = 'BUYER_SELLER'
                    res = await this.$api.createFictitiousOrder(data)
                    break
                default:
                    res = await this.$api.fullOrderCreate(data)
                    break
            }
            if (res.success) {
                if (res.data.imCustomerService) {
                    this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
                    let data = {
                        targetId: res.data.imCustomerService,
                        conversationType: 1
                    }
                    this.$store.dispatch('ry/join', data)
                    this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
                    this.$store.commit('ry/SET_ORDER_FLOW', [])
                    return
                }
                // 创建订单后埋点
                this.$trackEvent({ eventType: 'click', trackParams: { order_no: res.data.orderNo, goodsNo: this.detailsData.goodsNo } })
                // 创建订单成功后续处理
                this.parInfo = {
                    ...res.data,
                    payTotalMoney: res.data.payMoney,
                    transactionGoodsPrice: this.orderTypeTotalPrice
                }
                this.centerPayDialogVisible = true
                this.$nextTick(() => {
                    this.$refs['orderPayRef'].getPayqrCodeUrl(this.parInfo)
                    // 当前页面状态变更为待支付
                    addQueryParams({ ...this.$route.query, status: 'WAIT_PAY' })
                    // 获取订单详情
                    let _data = {
                        orderNo: res.data.orderNo
                    }
                    this.$api.orderDetails(_data).then(getRes => {
                        if (getRes.success) {
                            // 重新对 detailsData 进行赋值
                            this.detailsData = getRes.data
                            sessionStorage.setItem('orderDtl', JSON.stringify(this.detailsData))
                        }
                    })
                })
            } else {
                this.$message.error(res.info)
            }
        },
        // 检查是否被限制购买商品
        async onCheckLimit() {
            const par = {
                action: {
                    userBizLimited: 'PROXY_AGENCY_CREATE_ORDER'
                }
            }
            const check = await this.$api.checkOrderLimit(par)
            if (!check.data) {
                this.$message.error(check.info)
                return false
            }
            return true
        },
        // 意向金提交
        async paymentSubmit() {
            // 检查是否被限制购买商品
            const isRestrict = this.$store?.getters?.['user/checkUserRestrictMall'](RestrictMallCode.ALL_BUY)
            if (isRestrict) { return }

            const check = await this.onCheckLimit()
            if (!check) return
            if (this.parChangeState == false) {
                return this.$message.error('请阅读并勾选购买须知')
            }
            let data = {
                goodsNo: this.detailsData.goodsNo
            }
            switch (this.orderType) {
                case 'orderUpdatePricePay':
                    data.businessSource = 'UPDATE_PRICE'
                    break;
                case 'recyclePrice':
                    data.businessSource = 'RECLAIM'
                    break;
                case 'buyerSeller':
                    data.businessSource = 'BUYER_SELLER'
                    break;
                default:
                    break;
            }
            const res = await this.$api.getCheckGoodsStatus(data)
            if (res.success) {
                // 已有订单
                if (res.data !== null) {
                    return this.$router.push(`/account/buyerDetails?orderNo=${res.data}`)
                }
            } else {
                // 提示商品状态
                return this.$message.error(res.info)
            }
            if (this.$route.query.status == 'null' || !this.detailsData.orderNo) {
                // 商品不支持包赔。直接创建订单
                if (!this.detailsData?.compensation) {
                    let data = {
                        action: {
                            compensationId: null,
                            goodsNo: this.detailsData?.goodsNo,
                            valueAddCompensationIds: null,
                            couponsCode: null
                        }
                    }
                    this.paymentSubmitData(data)
                    return
                }
                // 有可用优惠卷但是未使用
                const _canUseCoupon = this.couponList?.some(res => res.canUse)
                if (_canUseCoupon && !this.selectedCoupon.hasOwnProperty('id')) {
                    this.couponTipsModalShow = true
                } else {
                    this.paymentSubmitToCreatOrder()
                }
            } else {
                this.$router.push({
                    path: '/account/buyerDetails',
                    query: { orderNo: this.detailsData.orderNo, parPage: 'true' } //, templateId: this.detailsData.templateId
                })
            }
        },
        // 创建订单
        async paymentSubmitToCreatOrder() {
            let _valueAddCompensationIds = null
            if (this.valueAddCompensationIds?.length > 0) {
                _valueAddCompensationIds = []
                this.valueAddCompensationIds.map(item => {
                    _valueAddCompensationIds.push(item.id)
                })
            }
            // 创建订单参数
            let data = {
                action: {
                    compensationId: this.selectedBasicCompensation.id || null,
                    goodsNo: this.detailsData.goodsNo,
                    valueAddCompensationIds: this.selectedPlusCompensation, // 选中的增值包赔id列表
                    couponsCode: this.selectedCoupon?.couponsCode, // 使用的优惠券编码
                    sharePrice: this.detailsData.price,
                    share: this.detailsData.share
                }
            }

            // 是否包赔服务必选
            if (!this.compensation.compensationBasicNeed && !this.compensation.compensationAddNeed) {
                // 是否选择了包赔 没有选择则弹窗
                if (data.action.compensationId || data.action.valueAddCompensationIds) {
                    this.paymentSubmitData(data)
                } else if (!this.basicCompensationList?.length) {
                    this.paymentSubmitData(data)
                } else {
                    const model = this.$pzDialog({
                        title: '确认信息',
                        content: '账号交易有发生找回的风险，若发生找回，平台将全力助您追回账号，若无法追回，平台将赔付30%号款。',
                        top: '15vh',
                        width: '450px',
                        cancelButtonText: '我已知晓',
                        confirmButtonText: '返回加购',
                        onConfirm: () => {
                            model.remove()
                        },
                        onCancel: () => {
                            this.paymentSubmitData(data)
                            model.remove()
                        }
                    })
                }
            } else {
                if (this.compensation.compensationBasicNeed && this.compensation.compensationAddNeed) {
                    if (!this.basicCompensationList.length || !this.plusCompensationList.length) {
                        this.$message.error('包赔服务错误，请联系客服')
                        return
                    } else if (!data.action.compensationId && !data.action.valueAddCompensationIds) {
                        this.$message.error('该商品需要至少加购一个【基础包赔类型+增值包赔类型】服务')
                        return
                    } else if (!data.action.compensationId) {
                        this.$message.error('该商品需要至少加购一个【基础包赔类型】服务')
                        return
                    } else if (!data.action.valueAddCompensationIds) {
                        this.$message.error('该商品需要至少加购一个【增值包赔类型】服务')
                        return
                    }
                }
                // 调用检查函数
                const isBasicCompensationValid = this.checkCompensation(
                    this.compensation.compensationBasicNeed,
                    this.basicCompensationList,
                    data.action.compensationId,
                    '该商品需要至少加购一个【基础包赔类型】服务'
                )
                const isAddCompensationValid = this.checkCompensation(
                    this.compensation.compensationAddNeed,
                    this.plusCompensationList,
                    data.action.valueAddCompensationIds,
                    '该商品需要至少加购一个【增值包赔类型】服务'
                )
                // 如果任一包赔类型不通过验证，则返回
                if (!isBasicCompensationValid || !isAddCompensationValid) {
                    return
                } else {
                    this.paymentSubmitData(data)
                }
            }
        },
        closePayModel() {
            this.centerPayDialogVisible = false
        },
        // 获取待支付详情
        getParOrderDtl() {
            let data = {
                orderNo: this.$route.query.orderNo || this.detailsData.orderNo
            }
            this.$api.orderDetails(data).then(res => {
                if (res.success) {
                    this.detailsData = res.data
                    this.parInfo = {
                        ...res.data,
                        payName: '意向金'
                    }
                }
            })
        },
        // 关闭支付方式弹窗
        closePayDialogVisible(done) {
            this.centerPayQRDialogVisible = true
            if (!this.centerPayQRDialogVisible) {
                done()
            }
        },
        // 退出支付方式
        closePayDialogOkVisible() {
            this.centerPayQRDialogVisible = false
            this.centerPayDialogVisible = false
            this.$refs['orderPayRef'].closeDialogVisible()
            this.$router.push({
                path: '/account/buyerDetails',
                query: { orderNo: this.detailsData.orderNo, parPage: 'true' }
            })
        },
        // 支付成功回调
        paySuccess(payStatus, msg = '支付失败') {
            if (payStatus === 'PAY_SUCCESS') {
                this.$message.success('支付成功！')
                // 是否是道具
                const isPropertyTrade = !!this.detailsData.isPropTrading
                this.$router.push({
                    path: '/confirmOrder/paymentCallback',
                    query: { orderNo: this.parInfo.orderNo, status: isPropertyTrade ? 3 : '' }
                })
            } else {
                this.centerPayDialogVisible = payStatus
                this.$refs['orderPayRef'].closeDialogVisible()
            }
        },
        /**
         *  获取包赔列表
         */
        async getCompensationList() {
            try {
                let data = {
                    action: {
                        goodsNo: this.detailsData?.goodsNo,
                        gameId: this.detailsData?.gameId
                    }
                }
                const fictitiousOrderId = this.$route.query.fictitiousOrderId
                if (fictitiousOrderId) {
                    data.action.fictitiousOrderId = fictitiousOrderId
                }
                switch (this.orderType) {
                    case 'LABEL':
                        data.action = { ...data.action, orderType: 'LABEL', labelId: this.$route.query.labelId }
                        break;
                    case 'orderUpdatePricePay':
                        data.action = { ...data.action, businessSource: 'UPDATE_PRICE', oldOrderNo: this.$route.query.oldOrderNo }
                        break;
                    case 'recyclePrice':
                        data.action = { ...data.action, businessSource: 'RECLAIM', reclaimPriceId: this.$route.query.reclaimPriceId }
                        break;
                    case 'buyerSeller':
                        data.action = { ...data.action, businessSource: 'BUYER_SELLER', coalitionPriceId: this.$route.query.reclaimPriceId }
                        break;
                    default:
                        break;
                }
                const res = await this.$api.createOrderCompensationList(data)
                if (!res.success) return this.$message.error(res.info)
                if (!res?.data?.length) return
                // 使用flatMap扁平化compensationServiceApiVOList列表，合并所有基础包赔和增值包赔
                const list = res.data.flatMap(item => item.compensationServiceApiVOList)
                // 基础包赔数据
                this.basicCompensationList = list.filter(item => item.type == 'BASIC_COMPENSATION')
                // 默认选中第一个基础包赔
                this.selectedBasicCompensation = this.basicCompensationList[0] || {}
                // 增值包赔数据
                this.plusCompensationList = list.filter(item => item.type == 'VALUE_ADD_COMPENSATION')
                // 如果开启必须选择增值包赔，则默认选中第一个增值包赔
                if (this.compensation.compensationAddNeed) {
                    this.selectedPlusCompensation = [this.plusCompensationList[0].id]
                }
                // 获取优惠券列表
                this.getWaitUseCouponList()
            } catch (error) {
                this.$message.error(error.$message)
            }

        },
        /**
         * @description 查询可用优惠券列表
         * @param compensationId 包赔ID
         */
        async getWaitUseCouponList() {
            // 商品价格
            let price = this.detailsData.price || this.detailsData.transactionPrice
            if (this.orderType === 'LABEL') {
                price = this.$route.query.labelPrice
            }
            // 计算增值包赔费用
            let addCompensationFee = 0
            if (this.selectedPlusCompensation.length) {
                // 计算已选中的增值包赔费用
                this.plusSelectedList.forEach(item => {
                    addCompensationFee += Number(item.compensationFee)
                })
            }
            let baseCompensationFee = 0
            let compensationId = null
            // 基础包赔是否已选择
            const leng = Object.keys(this.selectedBasicCompensation).length
            if (leng) {
                baseCompensationFee = Number(this.selectedBasicCompensation.compensationFee)
                compensationId = this.selectedBasicCompensation.id
            }
            const par = {
                gameId: this.$route.query?.gameId || this.detailsData?.gameId,
                price,
                baseCompensationFee, // 基础包赔费用
                addCompensationFee: addCompensationFee.toFixed(2) || 0, // 增值包赔费用
                compensationId // 基础包赔ID
            }

            this.couponLoading = true
            try {
                const res = await this.$api.getWaitUseCouponList(par)
                this.couponLoading = false
                if (!res.success) return this.$message.error(res.info)
                this.tabs[0].count = res.data.filter(item => item.canUse).length
                this.tabs[1].count = res.data.filter(item => !item.canUse).length
                // 优惠券列表
                this.couponList = res.data.filter(item => item.canUse === JSON.parse(this.activeName)).map(item => {
                    return {
                        ...item,
                        selected: false
                    }
                })
                // tab为不可用优惠券时，清空选中优惠券信息
                if (!JSON.parse(this.activeName)) {
                    this.selectedCoupon = {}
                    return
                }
                if (!this.couponList.length) return
                // tab为可用优惠券时，自动选择最优优惠券
                const couponInfo = this.couponList.reduce((prev, current) => {
                    const prevDiscount = this.calculateDiscount(prev)
                    const currentDiscount = this.calculateDiscount(current)
                    // 比较两个优惠券的实际抵扣金额，选择更高的
                    return prevDiscount > currentDiscount ? prev : current
                })
                couponInfo && this.onSelectCoupon(couponInfo)
            } catch (error) {
                this.couponLoading = false
                this.$message.error(error.message)
            }

        },
        /**
         * 计算优惠券抵扣金额
         * @param coupon 优惠券对象
         */
        calculateDiscount(coupon) {
            // 提前将数据解析并缓存，避免重复操作
            const compensationPrice = this.selectCompensationList.reduce((total, item) => total + Number.parseFloat(item.compensationFee || 0), 0)
            const couponValue = Number.parseFloat(coupon.couponsValue || 0)
            const scopeBusiness = Number.parseInt(coupon.scopeBusiness, 10)
            if (scopeBusiness === 1) {
                // 适用于包赔费用
                return Math.min(compensationPrice, couponValue)
            } else if (scopeBusiness === 2) {
                // 适用于订单总价
                const basicPrice = Number.parseFloat(this.orderTypeTotalPrice || 0)
                const totalPrice = basicPrice + compensationPrice
                return Math.min(totalPrice, couponValue)
            }
            // 默认返回 0（未知业务类型）
            return 0
        },
        /**
         * 选择基础包赔
         * @param e 选中的基础包赔对象
         * @param i 选中的基础包赔索引
         */
        handleSelectBasicCompensation(e, i) {
            // 先判断是否开启必须选择基础包赔
            if (this.compensation.compensationBasicNeed) {
                if (this.selectedBasicCompensation.id === e.id) return
                this.selectedBasicCompensation = e
                return
            } else {
                // 如果该商品非必选包赔，取消选中时
                if (this.selectedBasicCompensation.id === e.id) {
                    // 取消选中基础包赔时，清空选中的基础包赔
                    this.selectedBasicCompensation = {}
                    // 取消选中基础包赔时，清空选中的增值包赔
                    this.selectedPlusCompensation = []
                } else {
                    this.selectedBasicCompensation = e
                }
            }
            this.selectedCoupon = {}
            // 重新获取可用优惠券列表
            this.getWaitUseCouponList()
        },
        /**
         * 选择增值包赔
         * @param e 选中的增值包赔对象
         */
        handleCheckPlusCompensation(e) {
            // 先判断是否已经选择基础包赔
            const leng = Object.keys(this.selectedBasicCompensation).length
            if (!leng) return this.$message.error('须选择基础包赔后才可加购增值包赔')

            // 判断是否必选增值包赔
            if (this.compensation.compensationAddNeed) {
                // 必选增值包赔时，已选增值包赔数量为1时不可取消
                if (this.selectedPlusCompensation.length === 1 && this.selectedPlusCompensation.includes(e.id)) {
                    return
                } else {
                    // 必选增值包赔时，选择已选中的增值包赔时，取消选中
                    if (this.selectedPlusCompensation.includes(e.id)) {
                        this.selectedPlusCompensation = this.selectedPlusCompensation.filter(id => id !== e.id)
                    } else {
                        // 必选增值包赔时，选择未选中的增值包赔时，添加选中
                        this.selectedPlusCompensation.push(e.id)
                    }
                }
            } else {
                // 非必选增值包赔时，选择已选中的增值包赔时，取消选中
                if (this.selectedPlusCompensation.includes(e.id)) {
                    this.selectedPlusCompensation = this.selectedPlusCompensation.filter(id => id !== e.id)
                } else {
                    // 非必选增值包赔时，选择未选中的增值包赔时，添加选中
                    this.selectedPlusCompensation.push(e.id)
                }
            }
            console.log('this.selectedPlusCompensation======>>>', this.selectedPlusCompensation);
            // 重新获取可用优惠券列表
            this.getWaitUseCouponList()


        },
        /**
         * 选择优惠券
         * @param item 优惠券对象
         */
        onSelectCoupon(item) {

            this.couponList = this.couponList.map(res => {
                if (res.id === item.id) {
                    return { ...res, selected: !res.selected }
                } else {
                    return { ...res, selected: false }
                }
            })
            this.selectedCoupon = !item?.selected ? item : {}
        },
        /**
         * 选择是否使用优惠券
         * @param type creat 不使用优惠券，直接创建订单
         */
        onWhetherToUseCoupons(type) {
            this.closeModal()
            if (type === 'creat') {
                // 创建订单
                this.paymentSubmitToCreatOrder()
            }
        },
        // 关闭优惠卷使用提示弹框
        closeModal() {
            this.couponTipsModalShow = false
        },
        // 查询意向金计算
        getCalculateFee() {
            let data = {
                goodsNo: this.detailsData.goodsNo
            }
            this.$api.createOrderCalculateFee(data).then(res => {
                if (res.success) {
                    this.calculateFee = res.data
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        // 查看购买须知
        getNotice(id, title) {
            this.dialogTitle = title
            let data = {
                action: {
                    id
                }
            }
            this.$api.articleDetail(data).then(res => {
                if (res.success) {
                    this.articleDetail = res.data
                    this.centerDialogVisible2 = true
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        // 查看支付须知
        getPayNotice(id, title) {
            this.dialogTitle = title
            let data = {
                action: {
                    id
                }
            }
            this.$api.getHagglingDetail(data).then(res => {
                if (res.success) {
                    this.articleDetail = res.data
                    this.centerDialogVisible2 = true
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        /**
         * 查看包赔说明
         * @param item 包赔对象
         */
        compensationVisibleShow(item) {
            // 包赔服务信息
            this.compensationServiceInfo = { ...item }
            this.compensationVisible = true
        },
        /**
         * 加购包赔服务事件，在此事件中只能添加包赔服务，不能取消包赔服务
         * @param info 包赔服务对象
         */
        handleBuyService(info) {
            const { type } = info
            // 基础包赔
            if (type == 'BASIC_COMPENSATION') {
                this.selectedBasicCompensation = { ...info }
                this.totalPrice = this.orderTypeTotalPrice
            }
            // 增值包赔
            if (type == 'VALUE_ADD_COMPENSATION') {
                // 先判断是否已经选择基础包赔
                const leng = Object.keys(this.selectedBasicCompensation).length
                if (!leng) return this.$message.error('须选择基础包赔后才可加购增值包赔')
                // 判断当前增值包赔是否已选择
                if (!this.selectedPlusCompensation.includes(info.id)) {
                    this.selectedPlusCompensation.push(info.id)
                }
            }
            // 重新获取优惠券列表
            this.getWaitUseCouponList()
            // 关闭弹窗
            this.compensationVisible = false
        },
        getWantAndSeenNum(goodsNo,onStandTime) {
            this.$api.getGoodsWantAndSeenNum({action:[{goodsNo,onStandTime}]}).then(res => {
                if (res.success) {
                    this.wantNum = res.data[0].wantNum || 0;
                    this.wantBuyText = formatCount(this.wantNum);
                    this.shouldAnimate = true;
                    setTimeout(() => {
                        this.shouldAnimate = false;
                    }, 600);
                }
            })
        },
        /**
         * 获取商品详情
         */
        async onLoadDetailsData() {
            try {
                const data = {
                    action: {
                        goodsNo: this.$route.query.goodsNo
                    }
                }
                const res = await this.$api.goodsDetails(data)
                if (!res.success) return this.$message.error(res.info)
                if(res.data.goodsNo && res.data.onStandTime) {
                    this.getWantAndSeenNum(res.data.goodsNo,res.data.onStandTime);
                }
                this.detailsData = res.data
            } catch (error) {
                this.$message.error(error.message)
            }
        },
        /**
         * 获取游戏配置详情
         * @param val
         */
        async getGameConfigData(val) {
            let data = {
                action: {
                    gameId: val?.gameId,
                    goodsCatalogueId: val?.goodsCatalogueId,
                    goodsNo: val?.goodsNo
                }
            }
            const res = await this.$api.getGameConfig(data)
            if (!res.success) {
                this.$message.error(res.info)
                return
            }
            this.compensation = {...res.data[0]}
        }
    },
    async mounted() {
        this.detailsData = JSON.parse(sessionStorage.getItem('orderDtl'))
        if (this.$route.query.status == 'WAIT_PAY') {
            this.getParOrderDtl()
        }

        this.$api.getActivityBenefitInviteCode({ gameId: this.$route.query?.gameId || this.detailsData?.gameId }).then(res => {
			if (res.success) {
                console.log(res,'res');
                
				this.inviteInfo = res.data
			    // 将邀请码同步到表单数据中
				this.inviteCode = res.data.inviteCode || ''
	     	}
	    })
    }
}
